import { render, staticRenderFns } from "./SaveFailureBanner.vue?vue&type=template&id=5a46a13b&"
import script from "./SaveFailureBanner.vue?vue&type=script&lang=js&"
export * from "./SaveFailureBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports